import { tableBlueprint } from "@made-people/blueprint-table/blueprint";

tableBlueprint.override({
  slots: {
    base: "overflow-x-auto rounded-none",
    table: "min-w-full border-collapse border-0",
    headingWrapper: "bg-surface-1 border-0",
    heading:
      "px-4 py-2 text-left text-label-md border-0 min-w-[120px] font-bold",
    body: "bg-white border-0",
    row: "even:bg-surface-1 border-0",
    item: "px-4 py-2 text-body-sm text-gray-600 text-left font-medium border-0 min-w-[120px]",
  },
});
